import { gql } from "@apollo/client";export default gql`mutation deleteQuestion($id: Int!) {
    deleteQuestion: delete_question_by_pk(id: $id) {
        id
    }
}
`;
